import type { RouteRecordRaw } from 'vue-router'
import { page } from './utils'
import { BarBackgroundStyle } from '@/composables/useNativeStyle'

const loginRegistrationRoutes: RouteRecordRaw[] = [
  {
    path: '/start',
    name: 'start',
    component: page('authentication/StartPage'),
    meta: {
      showGradient: true,
      disableNativeBackButton: true,
      statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
    },
  },
  {
    path: '/loading',
    name: 'loading',
    component: page('LoadingPage'),
    meta: {
      statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
    },
  },
  {
    path: '/registration',
    name: 'registration',
    component: page('authentication/RegistrationPage'),
    meta: {
      showGradient: true,
      statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
    },
  },
  {
    path: '/codeAuth/:code?',
    name: 'codeAuth',
    component: page('authentication/company-code-path/CodeAuthPage'),
    props: (route) => {
      return { initialCode: route.params.code }
    },
    meta: {
      showGradient: true,
      statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
    },
  },
  {
    path: '/deviceName',
    name: 'deviceName',
    component: page('authentication/qr-auth-path/SelectDeviceNamePage'),
    meta: {
      showGradient: true,
      statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
    },
  },
  {
    path: '/login:email?',
    name: 'login',
    component: page('authentication/LoginPage'),
    props: (route) => {
      return { initialMail: route.params.email }
    },
    meta: {
      showGradient: true,
      statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
    },
  },
  {
    path: '/requestPassword/:email?',
    name: 'requestPassword',
    component: page('authentication/RequestPasswordPage'),
    props: (route) => {
      return { initialMail: route.params.email }
    },
    meta: {
      showGradient: true,
      statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
    },
  },
  {
    path: '/passwordRequested/:email?',
    name: 'passwordRequested',
    component: page('authentication/PasswordRequestedPage'),
    props: (route) => {
      return { initialMail: route.params.email }
    },
    meta: {
      showGradient: true,
      statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
    },
  },
]

export default loginRegistrationRoutes
